import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.users');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router'

@Component({
    selector: 'wiz-portal-gsdcadmin-community-users',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.users/view.scss */
/* src/app/portal.gsdcadmin.community.users/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityUsersComponent implements OnInit, OnDestroy {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    public users: any = [];
    public community: any = {};

    public pagination: any = {
        page: 1,
        start: 1,
        end: 1
    }
    public searchTerm = "";
    public total = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { text: this.searchTerm, page: this.pagination.page, communityID: this.community_id });
        if (code != 200) return window.location="/dashboard";
        this.users = data.users;
        this.community = data.community;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }

    public async changeLeader(user: any, event: Event) {
        const checkbox = event.target as HTMLInputElement;

        const original = user.representative;               // 'Y' or 'N'
        const next = checkbox.checked ? 'Y' : 'N';          // 클릭 후 상태

        user.representative = next;
        await this.service.render();

        let res: any;
        if (next === 'Y') {
            res = await this.service.alert.show({ title: "연구커뮤니티 대표 지정", message: "해당 사용자를 연구커뮤니티 대표로 지정하시겠습니까?", action: "지정", cancel: "취소", actionBtn: 'success', status: 'success' });
        } else {
            res = await this.service.alert.show({ title: "연구커뮤니티 대표 해제", message: "해당 사용자를 연구커뮤니티 대표 해제하시겠습니까?", action: "해제", cancel: "취소", actionBtn: 'error', status: 'error' });
        }

        if (res !== true) {
            user.representative = original;
            await this.service.render();   // ← 이게 없으면 체크박스 UI 안 바뀜
            return;
        }

        const { code } = await wiz.call("changeLeader", { user: JSON.stringify(user), community: JSON.stringify(this.community) });

        if (code !== 200) {
            // 실패 시에도 롤백
            user.representative = original;
            await this.service.render();
            return;
        }

        await this.service.alert.success("연구커뮤니티 대표 지정/해제 완료했습니다.");
    }
}

export default PortalGsdcadminCommunityUsersComponent;